import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Projects from './components/Projects';
import ClientsCarousel from './components/ClientsCarousel';
import Contact from './components/Contact';
import Footer from './components/Footer';
//import TechnologiesCarousel from './components/TechnologiesCarousel';
import WhatsAppButton from './components/WhatsAppButton';

const App = () => {
  return (
    <div>
      <Header />
      <HeroSection />
      <AboutUs />
      <Services />
      <Projects />
      {/*<TechnologiesCarousel />*/}
      <ClientsCarousel />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
